// extracted by mini-css-extract-plugin
export var active = "langSwitch-module--active--fea7b";
export var wrapper = "langSwitch-module--wrapper--86657";